(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo_slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function loadScript(url, callback) {
    var script = document.createElement('script');
    script.src = url;
    script.onload = callback;
    document.head.appendChild(script);
  }

  function loadStyle(url) {
    var link = document.createElement('link');
    link.href = url;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }

  function initSlick($) {
    $('.js-logo-slider').not('.slick-initialized').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      dots: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: { slidesToShow: 4 }
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 2 }
        }
      ]
    });
  }

  function safeInit() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => initSlick(jQuery));
    } else {
      setTimeout(() => initSlick(jQuery), 200);
    }
  }

  function loadAndInitSlick() {
    if (typeof jQuery === 'undefined') {
      loadScript('https://code.jquery.com/jquery-3.6.0.min.js', function () {
        loadStyle('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css');
        loadStyle('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css');
        loadScript('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js', function () {
          safeInit();
        });
      });
    } else {
      loadStyle('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css');
      loadStyle('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css');
      loadScript('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js', function () {
        safeInit();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    loadAndInitSlick();
  });
  

  // Re-init when section loads dynamically (Shopify)
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.js-logo-slider')) {
      loadAndInitSlick();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab_collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.tab-button');
  const tabPanels = document.querySelectorAll('.tab-panel');

  tabButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const targetId = btn.dataset.tab;
      const panel = document.getElementById(targetId);
      if (btn.classList.contains('active')) {
        btn.classList.remove('active');
        panel.classList.remove('active');
        return;
      }

      tabButtons.forEach(b => b.classList.remove('active'));
      tabPanels.forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      panel.classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
